import React, { useState } from 'react';
import { FiSmartphone } from 'react-icons/fi';
import Modal from 'components/basicos/Modal';
import BridgeCapture from './BridgeCapture';
import { useDeviceBridge } from 'shared/deviceBridge';
import API from 'shared/api';

const TITULOS = {
  foto: 'Foto desde el celular',
  escanear_codigo: 'Escanear código',
};

export default function BridgeInbox() {
  const { pendientes, responder, rechazar } = useDeviceBridge();
  const [activa, setActiva] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const primera = pendientes[0];

  const abrir = (p) => setActiva(p);

  const cerrar = async () => {
    setActiva(null);
  };

  const rechazarActual = async () => {
    if (!activa) return;
    const id = activa.request_id;
    await rechazar(id).catch(() => {});
    setActiva(null);
  };

  const completar = async (resultado) => {
    if (!activa) return;
    setEnviando(true);
    try {
      let payload = resultado;
      if (activa.tipo === 'foto' && resultado?.foto) {
        const fd = new FormData();
        fd.append('archivo', resultado.foto, resultado.foto.name || 'foto.jpg');
        const destino = activa.params?.destino;
        if (destino === 'comprobante_pago' && activa.params?.pedido_id && activa.params?.pago_id) {
          fd.append('schema_name', localStorage.getItem('agorax_empresa_slug') || 'negocio');
          const r = await API.post(
            `/pedidos/${activa.params.pedido_id}/pagos/${activa.params.pago_id}/comprobante`,
            fd
          );
          const url = r.data?.data?.comprobante_url;
          if (!url) throw new Error('Sin URL de comprobante');
          payload = { url, pedido_id: activa.params.pedido_id, pago_id: activa.params.pago_id };
        } else {
          const r = await API.post('/bridge/subir-archivo', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          const url = r.data?.data?.url;
          if (!url) throw new Error('Sin URL de la foto');
          payload = { url };
        }
      }
      await responder(activa.request_id, 'completado', payload);
      setActiva(null);
    } catch (e) {
      console.warn('Error completando petición bridge:', e);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      {primera && !activa && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            maxWidth: '420px',
            margin: '0 auto',
            zIndex: 1200,
            background: 'var(--agx-surface)',
            border: '1px solid var(--agx-border)',
            borderRadius: '14px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            padding: '14px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            cursor: 'pointer',
          }}
          onClick={() => abrir(primera)}
        >
          <FiSmartphone size={22} style={{ color: 'var(--agx-text)', flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--agx-text)' }}>
              {TITULOS[primera.tipo] || 'Solicitud recibida'}
            </div>
            <div style={{ fontSize: '12px', color: 'var(--agx-muted)' }}>
              {primera.origen_nombre ? `Desde ${primera.origen_nombre} · ` : ''}toca para abrir
            </div>
          </div>
        </div>
      )}

      <Modal
        open={!!activa}
        onClose={cerrar}
        title={(activa && TITULOS[activa.tipo]) || 'Solicitud'}
        width="sm"
      >
        {activa && (
          <BridgeCapture
            tipo={activa.tipo}
            onCompletado={completar}
            onCancelar={rechazarActual}
          />
        )}
        {enviando && (
          <div style={{ textAlign: 'center', color: 'var(--agx-muted)', paddingTop: 12, fontSize: 13 }}>
            Enviando…
          </div>
        )}
      </Modal>
    </>
  );
}
